class QueryDomMethods {
    shadowRoot?: ShadowRoot;
    setShadowRoot = (root: ShadowRoot) => {
        this.shadowRoot = root;
    };
    querySelector = (name: string) => {
        console.log(this.shadowRoot);
        return (this.shadowRoot ? this.shadowRoot.querySelector(name) : document.body.querySelector(name)) as any;
    };
    querySelectorAll = (name: string) => {
        return this.shadowRoot ? this.shadowRoot.querySelectorAll(name) : document.body.querySelectorAll(name);
    };
    querySubTikuRoot = () => {
        return (this.shadowRoot ? this.shadowRoot.querySelector('#sub-tiku')! : document.body.querySelector('#sub-tiku')!) as any;
    };
}

export default new QueryDomMethods();
